import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostFilterOptionsFetchFailedAction = {
	type: 'AI_COST_FILTER_OPTIONS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostFilterOptionsFetchFailedAction => ({
	type: 'AI_COST_FILTER_OPTIONS_FETCH_FAILED',
	payload,
});
